<template>
  <div class="container container-main py-2 md:py-[16px] bg-white">
    <router-link :to="{ name: '/home' }" class="block mx-auto xl:mr-[24px] xl:mx-0 xl:shrink-0">
      <figure v-if="theme === 'default'">
        <img loading="lazy" src="/img/logo/logo-green.svg" alt="logo" class="w-[93px] md:w-[142px]" />
      </figure>
      <figure v-else>
        <img loading="lazy" src="/img/logo/logo-kids.svg" alt="logo" class="w-[93px] md:w-[142px] xl:block hidden" />
        <img
          loading="lazy"
          src="/img/logo/logo-kids-mobile.svg"
          alt="logo-mobile"
          class="min-[350px]:w-[180px] w-[121px] xl:hidden block"
        />
      </figure>
    </router-link>
  </div>
</template>
<script setup>
import { theme } from "@/services/getSiteTheme"
</script>
